import { render, staticRenderFns } from "./ModulosModalNuevo.vue?vue&type=template&id=69a5233b&scoped=true&"
import script from "./ModulosModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./ModulosModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./ModulosModalNuevo.vue?vue&type=style&index=0&id=69a5233b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a5233b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('69a5233b', component.options)
    } else {
      api.reload('69a5233b', component.options)
    }
    module.hot.accept("./ModulosModalNuevo.vue?vue&type=template&id=69a5233b&scoped=true&", function () {
      api.rerender('69a5233b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mantenedores/ModulosModalNuevo.vue"
export default component.exports